import { ComponentType } from 'react';

export const withStaticProperties = <
  MainComponent extends ComponentType<any>, // eslint-disable-line @typescript-eslint/no-explicit-any
  StaticComponent extends Record<string, ComponentType<any>>, // eslint-disable-line @typescript-eslint/no-explicit-any
>(
  component: MainComponent,
  props: StaticComponent,
): MainComponent & StaticComponent => {
  Object.assign(component, props);

  return component as MainComponent & StaticComponent;
};
